import script from "./carousel-picture.vue?vue&type=script&setup=true&lang=ts"
export * from "./carousel-picture.vue?vue&type=script&setup=true&lang=ts"

import "./carousel-picture.vue?vue&type=style&index=0&id=fb5b9d48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb5b9d48"]])

export default __exports__